import { render, staticRenderFns } from "./goldsilveroutreturnHistory.vue?vue&type=template&id=46cdcf47&scoped=true&"
import script from "./goldsilveroutreturnHistory.vue?vue&type=script&lang=js&"
export * from "./goldsilveroutreturnHistory.vue?vue&type=script&lang=js&"
import style0 from "./goldsilveroutreturnHistory.vue?vue&type=style&index=0&id=46cdcf47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cdcf47",
  null
  
)

export default component.exports